<svg width="24" height="24" viewBox="0 0 24 24" fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="11" stroke="#000" stroke-width="1.5"/>
  <path d="M11.25 10.25C11.25 9.83579 11.5858 9.5 12 9.5C12.4142 9.5 12.75 9.83579 12.75 10.25V16.25C12.75 16.6642 12.4142 17 12 17C11.5858 17 11.25 16.6642 11.25 16.25V10.25Z" fill="#000"/>
  <path d="M11.25 7.75C11.25 7.33579 11.5858 7 12 7C12.4142 7 12.75 7.33579 12.75 7.75C12.75 8.16421 12.4142 8.5 12 8.5C11.5858 8.5 11.25 8.16421 11.25 7.75Z" fill="#000"/>
</svg>
